var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 6,
    viewBox: "0 0 23 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.771 3.078a2.62 2.62 0 0 0 .784 1.873 2.68 2.68 0 0 0 1.893.776 2.7 2.7 0 0 0 1.893-.776 2.65 2.65 0 0 0 .784-1.873c0-.702-.282-1.376-.784-1.872A2.7 2.7 0 0 0 11.448.43a2.7 2.7 0 0 0-1.893.776 2.63 2.63 0 0 0-.784 1.872m-3.162 0a2.62 2.62 0 0 0-.784-1.871A2.68 2.68 0 0 0 2.932.432a2.7 2.7 0 0 0-1.891.777A2.65 2.65 0 0 0 .258 3.08c0 .702.282 1.375.784 1.871a2.7 2.7 0 0 0 1.893.775c.71 0 1.39-.28 1.891-.777.502-.496.783-1.17.783-1.872m11.676 0c0 .703.282 1.376.784 1.873a2.7 2.7 0 0 0 1.893.776c.71 0 1.39-.28 1.893-.776a2.63 2.63 0 0 0 0-3.745A2.7 2.7 0 0 0 19.962.43c-.71 0-1.391.28-1.893.776a2.63 2.63 0 0 0-.784 1.872",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.00bfdf131ec9ceed3329f05b90b9cdae.svg";
export { ForwardRef as ReactComponent };